import { IRootState } from '../../../store'
import { IDataPointsConfig } from '../store/configurations.types'

export const getDatapointsConfigSelector = (state: IRootState): IDataPointsConfig =>
  state.configurations.datapointsConfig
